import { INotification } from './i-notification.interface';

import { BusinessObject } from "../../../shared/business-object.model";
import { NotificationType } from "./notification-type.enum";

export class Notification extends BusinessObject implements INotification {
	constructor(item: any) {
		super(item);

		if (!item) { return; }

		const payloadObject = JSON.parse(item.payload);
		this.message = payloadObject.message;
		this.category = payloadObject.category;
		this.dataId = payloadObject.dataId;
		this.tableName = payloadObject.tableName;
		this.fieldName = payloadObject.fieldName
		this.trackAndTraceResultId = payloadObject.trackAndTraceResultId;
		this.trackAndTraceRequestId = payloadObject.trackAndTraceRequestId;
		this.isExpanded = false;
		this.isLoading = false;
		this.warningMessage = payloadObject.warningMessage;
		this.errorMessage = payloadObject.errorMessage;
		this.railcar = payloadObject.railcar;
		this.splcLocation = payloadObject.splcLocation;
		this.notificationType = payloadObject.notificationType;

		if (this.category === 'Track & Trace Alert' && (item.title === 'Railcar CP\'d' ||
			item.title === 'Approve arrival date at scrap service event.' || item.title === 'Railcar Arrived At Destination')) {
			if (!!payloadObject.value) {
				this.value = this.dateParse(payloadObject.value);
			} else {
				this.value = new Date(Date.now());
			}
		} else {
			this.navigateUrl = this.getNavigationUrl(payloadObject);
		}

		this.changedValue = this.value;
	}
	title: string;
	recipient: string;
	createdDate: Date;
	ageOfMessage: string;
	payload: string;

	message: string;
	category: string;
	dataId: number;
	tableName: string;
	value: any;
	changedValue: any;
	fieldName: string;
	warningMessage: string;
	errorMessage: string;
	trackAndTraceResultId: number;
	trackAndTraceRequestId: number;
	railcar: any;
	splcLocation: any;

	dismissed: boolean;
	isExpanded: boolean;
	isLoading: boolean;
	navigateUrl: string;
	queryParams: any;
	notificationType: string;

	templateData: any;
	hideNotification: boolean;

	oldValue: string;
	newValue: string;
	notificationId: number;
	get dismissAnimation(): string {
		return this.hideNotification ? 'hide' : 'show';
	}

	getNavigationUrl(payloadObject: any): string {
		switch (payloadObject.notificationType) {
			case NotificationType.APInvoiceDetailsPage:
				return '/carrepairbilling/invoice/ap/detail/' + this.dataId;
			case NotificationType.EstimatePage:
				return '/carrepairbilling/estimate/' + this.dataId;
			case NotificationType.LeaseDetailsPage:
				return '/commercial/lease/' + this.dataId;
			case NotificationType.ProgramworkPage:
				var action = payloadObject.value === 'openPublish' ? 'openPublish' : null;
				if (!!action) {
					return '/fleet/programwork/' + this.dataId + '/' + action;
				} else {
					return '/fleet/programwork/' + this.dataId;
				}
			case NotificationType.ProgramworkSearch:
				return 'fleet/programwork/search';
			case NotificationType.ServiceEventDetailsPage:
				return '/fleet/serviceevent/' + this.dataId;
			case NotificationType.TrackandTraceSearchPage:
				return '/commercial/trackandtrace/search/' + this.trackAndTraceRequestId;
			case NotificationType.AuditPage:
				const value = payloadObject.value.split('|');
				this.queryParams = { crbFileId: Number(value[0]), invoiceNumber: String(value[1]), shopCode: String(value[2])};
				return '/carrepairbilling/invoice/audit/detail';
			case NotificationType.RailincFiles:
				return '/fleet/report/railincFiles';
			case NotificationType.FreightApPageReady:
				this.queryParams = { progress: 'ready' };
				return '/freight/invoice/ap';
			case NotificationType.FreightApPageApproved:
				this.queryParams = { progress: 'approved' };
				return '/freight/invoice/ap';
			case NotificationType.CarHireSearchPage:
				return '/commercial/carhire/search';
			case NotificationType.BaseRentalReport:
				return '/commercial/report/baseRentalAdjustment';
			default:
				this.value = payloadObject.value
				break;
		}
	}
}